import { useRef, type ReactNode } from "react";
import { TooltipProvider } from "./components/ui/tooltip";
import { PortalContainerProvider } from "./portal-context";

/**
 * Shared shell for all replay widgets. Wraps the widget content with the
 * tooltip provider and a portal container scoped to the widget root, so
 * tooltip DOM stays inside the scoped CSS tree.
 *
 * Each widget package renders its own ReplayPage (or variant) as children.
 */
export function ReplayWidgetShell({ children }: { children: ReactNode }) {
  const rootRef = useRef<HTMLDivElement>(null);
  return (
    <div ref={rootRef} className="githits-replay-root">
      <PortalContainerProvider containerRef={rootRef}>
        <TooltipProvider>{children}</TooltipProvider>
      </PortalContainerProvider>
    </div>
  );
}
